<template lang="pug">
  .component-packet-vehicle-category-list
    .row
     .columns.large-offset-11.text-right
       PacketVehicleCategoryModal(@itemUpdated="itemUpdated")
    .row
     .column
       base-list(:component="component" :dataLoader="dataLoader", :showPerPageSelect="true", ref="list")
</template>

<script>
import PacketVehicleCategoryModal from "../../components/structure/ui/actions/reveal/PacketVehicleCategoryModal";
import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
import BaseList from "./BaseList";

export default {
  name: "PacketVehicleCategoryList",
  components: {PacketVehicleCategoryModal,BaseList},
  data: function () {
    return {
      component: require('src/components/backoffice/PacketVehicleCategory.vue'),
    }
  },
  created() {
  },
  methods: {
    dataLoader(callback) {
      KeplerBackofficeSdk.packetVehicleCategories.list.all(1,25 ,(data)=> {
        callback(data)
      })
    },
    itemUpdated(op) {
      if(op === 'added') {
        this.$refs.list.loadData(1)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketVehicleCategoryList.vue?64dc56de